<template>
  <div class="mk-override">
    <div class="mk-override__container">
      <span class="mk-override__title">
        {{$t('override.title')}}
      </span>
      <div class="mk-override__description">
        {{$t('override.message')}}
      </div>
      <button
        class="mk-override__secondary"
        @click="closeCallback"
      >
        {{$t('override.cancel')}}
      </button>
      <button
        class="mk-override__primary"
        @click="submitCallback"
      >
        {{$t('override.proceed')}}
      </button>
    </div>
  </div>
</template>

<script>
/**
 * Override Configuration Warning
 * @author David <david.prenninger@gmx.de>
 *
 * This component shows a warning to indicate that the configuration
 * will be overridden if the action is continued.
 */
export default {
  props: {
    closeCallback: Function,
    submitCallback: Function,
  },
};
</script>


<style lang="scss" scoped>
@import "@/assets/style/defaults.scss";

.mk-override {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba($c_primary, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;

  &__title {
    font-size: 20px;
  }

  &__container {
    background-color: $c_white;
    padding: 10px;
    box-shadow: $bs_md;
    border-radius: $br_md;
    color: $c_primary;
  }

  &__description {
    padding: 20px 10px;
    margin: 5px 0;
  }

  &__secondary {
    background-color: $c_white;
    margin: 5px 10px;
    color: $c_accent;
    padding: 10px 20px;
    border-radius: $br_md;
    box-shadow: $bs_md;
    border: none;
    width: fit-content;
  }

  &__primary {
    margin: 5px 10px;
    background-color: $c_accent;
    color: $c_white;
    padding: 10px 20px;
    border-radius: $br_md;
    box-shadow: $bs_md;
    border: none;
    width: fit-content;
  }
}
</style>
